import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrencyDto } from '../../services/api.services';
import * as AppReducer from './app.reducer';

export const selectFeature = createFeatureSelector<AppReducer.State>('app');


export const pageComponent = createSelector(
  selectFeature,
  state => state.pageComponent
);

export const pageComponentId = createSelector(
  selectFeature,
  state => state.pageComponentId
);


export const isUserAvailable = createSelector(
  selectFeature,
  state => !!state.user
);

export const getUser = createSelector(
  selectFeature,
  state => state.user
);

export const getUserClaims = createSelector(
  selectFeature,
  state => state.userClaims
);

export const userLoaded = createSelector(
  selectFeature,
  state => state.userLoaded
);

export const userLoadFailed = createSelector(
  selectFeature,
  state => state.userLoadFailed
);


export const enterpriseUserData = createSelector(
  selectFeature,
  state => state.enterpriseUserData
);

export const clientCustomization = createSelector(
  selectFeature,
  state => state.clientCustomization
);

export const isSavingUserState = createSelector(
  selectFeature,
  state => state.savingUserState
);

export const getUserState = createSelector(
  selectFeature,
  state => state.userState
);

export const getSettings = createSelector(
  selectFeature,
  state => state.settings
);

export const getProducts = createSelector(
  selectFeature,
  state => state.products
);

export const appProducts = createSelector(
  selectFeature,
  state => state.appProducts
);

export const getItemCategories = createSelector(
  selectFeature,
  state => state.itemCategories
);

export const schedulerConfig = createSelector(
  selectFeature,
  state => state.schedulerConfig
);

export const getFeatures = createSelector(
  selectFeature,
  state => state.features
);

export const locales = createSelector(
  selectFeature,
  state => state.locales
);

export const loaded = createSelector(
  selectFeature,
  state => state.loaded
);
